cv.RootView = Marionette.LayoutView.extend({
  el: 'body',

  regions: {
    app: "#app"
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    'show' : function(view) {
      this.post_show(view);
    },
    'render' : function() {
    }
  },

  initialize: function(options){
    this.options = _.extend({
      bypass_all_links : false
    }, options);

    this.post_show = _.debounce(_.bind(function(view){
      console.groupEnd();
      console.group('Showing view...');

      // Old stuff
      // Remove all labels
      this.$('.notif.error, .help-label').remove();

      // Remove notifications
      vent.trigger('notif:clear');

      console.log('Firing post show...');
    }, this), 500, false);

    // Listeners
    this.listenTo(cv.pay, 'change:iframe_type', function(model){
      this.$el.addClass('pay-' + model.get('iframe_type'));
    }, this);

    // Bind the bypass link handler
    if(this.options.bypass_all_links == false){
      this.$('#content, #top').on('click', 'a:not([data-bypass])', function (e) {
        var href = $(this).attr('href');
        var protocol = this.protocol + '//';

        // Check for prevent default and hashed urls
        if(!e.isDefaultPrevented() && !_.isUndefined(href) && href != '#'){
          // Navigate if we are an internal url
          if(href.slice(protocol.length) !== protocol) {
            e.preventDefault();

            Backbone.history.navigate(href, true);
          }
        }
      });
    }

    // Remove the bootloader
    this.$('.boot-loader').remove();

    console.log('RootView initialized.');
  }
});

// Before start
cv.on('before:start', function(options){
  var view_options = {};
  var dev_info = false;

  // Set up the API path and preloaded things
  cv.api_path = options.PRELOADED.api_path;
  cv.unsaved_views = {};
  cv.PRELOADED = options.PRELOADED;

  // Set up the router
  cv.router = new cv.Router();

  // Set up the initial models
  if(!_.isUndefined(options.PRELOADED.campaign)){
    cv.campaign = new cv.Campaign({ data : options.PRELOADED.campaign }, { parse : true, synced : true });
    console.log(cv.campaign.attributes);
  }

  // Set up API key
  cv.setupPrefilter('api_key', options.PRELOADED.public_api_key);

  // Set CSRF protection
  Cookies.set('cv_csrf', cv.PRELOADED.csrf_token, { path: '/' });
  cv.setupPrefilter('csrf', cv.PRELOADED.csrf_token);

  // Set up the initial pay model
  cv.pay = new Backbone.Model({
    campaign_id : cv.PRELOADED.campaign_id,
    project_id : cv.PRELOADED.project_id,
    team_id : cv.PRELOADED.team_id,
    recipient : null,
    submitting_payment : false,
    amount: '',
    custom_amount : '',
    recurring : 0,
    tip_changed : false,
    recipient_menu: false,
    recipient_loaded: false,
    recipient_filter: 'all',
    add_tip: 1,
    tip : 0,
    tip_percent : 0.15,
    comment : '',
    address : '',
    address2 : '',
    city : '',
    zipcode : '',
    state : '',
    country : '',
    anonymous : 0,
    subscribe : 0,
    giftaid: 0
  });

  // Set up some default countries
  if(cv.campaign.get('currency_code') == 'USD'){
    cv.pay.set('country', 'US');
  }
  if(cv.campaign.get('currency_code') == 'CAD'){
    cv.pay.set('country', 'CA');
  }

  // Set the default subscribe state
  if(cv.campaign.get('subscribe_default') == 1){
    cv.pay.set('subscribe', 1);
  }

  // Set some default/mandatory recurring stuff
  if(cv.campaign.get('enable_recurring') == 1 && (cv.campaign.get('recurring_default') == 1 || cv.campaign.get('recurring_mandatory') == 1)){
    cv.pay.set('recurring', 1);
  }

  if(cv.campaign.get('enable_recurring') == 0){
    cv.pay.set('recurring', 0);
  }

  // Set some defaults for development environment
  if(cv.environment == 'development' && dev_info == true){
    // Set initial values
    cv.pay.set({
      first_name : 'Jefferson',
      last_name : 'Chang',
      comment : 'Here is a comment!',
      email : 'ookblah@gmail.com',

      // For mobile payments setting
      state : 'Alabama',
      country : 'US'
    });

    // Set postal stuff if it's enabled
    if(cv.campaign.get('enable_postal') == 1){
      cv.pay.set({
        address : '1234 Main Street',
        address2 : '',
        city : 'New York',
        zipcode : 12345
      });
    }
  }

  // Sentry configuration
  if(cv.environment != 'development'){
    Raven.config('https://78f90194ed1a416ca179301e1976c4d6@sentry.io/123855', {
      environment: cv.environment
    }).install();
  }
  
  // Set up the root view
  cv.rootView = new cv.RootView(view_options);

  // Set up iframe type after we render the rootview
  if(window.name.split('-')[0] == 'modal'){
    cv.pay.set('iframe_type','modal');
  }
  if(window.name.split('-')[0] == 'embed'){
    cv.pay.set('iframe_type','embed');
  }
});

cv.on('start', function(options){
  if (Backbone.history){
    Backbone.history.start({ pushState : true });
  }
});
